import classNames from 'classnames';
import React, { CSSProperties, FC, ReactNode } from 'react';
import ClickAwayListener from 'react-click-away-listener';
import styled, { Interpolation } from 'styled-components';

interface DrawerProps {
    anchor: 'left' | 'top' | 'right' | 'bottom';
    open: boolean;
    children: ReactNode;
    className?: string;
    classes?: {
        root?: string;
        content?: string;
    };
    styles?: Interpolation<CSSProperties>;
    handleClose: () => void;
    isBackdropHidden?: boolean;
}
interface DrawerStyledProps {
    anchor: 'left' | 'top' | 'right' | 'bottom';
    styles?: Interpolation<CSSProperties>;
}

const DrawerContainer = styled.div`
    position: fixed;
    z-index: 9001;
`;

const DrawerBackdrop = styled.div`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: -1;
    position: fixed;
    align-items: center;
    justify-content: center;
    -webkit-tap-highlight-color: transparent;
    ${({ theme: { colors } }) => `
        background-color: ${colors.background.overlay.v5};
    `}
`;

const DrawerContent = styled.div<DrawerStyledProps>`
    transform: none;
    transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    position: fixed;
    z-index: 800;
    ${({ anchor }) => `
        ${
            anchor == 'left'
                ? `left: 0;
                        right: auto;`
                : anchor == 'top'
                ? `top: 0;
                        left: 0;
                        bottom: auto;
                        right: 0;`
                : anchor == 'bottom'
                ? `top: auto;
                        left: 0;
                        bottom: 0;
                        right: 0;`
                : anchor == 'right'
                ? `left: auto;
                        right: 0;`
                : ``
        };
    `}
    ${({ styles }) => styles};
`;

const Drawer: FC<DrawerProps> = ({
    children,
    styles,
    className,
    classes,
    open,
    anchor,
    handleClose,
    isBackdropHidden = false,
}) => {
    const clickAwayHandle = (e: Event) => {
        e.preventDefault();
        handleClose();
    };
    return open ? (
        <DrawerContainer
            className={classNames('drawer', className, classes && classes.root && classes.root)}
        >
            {!isBackdropHidden && (
                <DrawerBackdrop
                    aria-hidden="true"
                    style={{
                        opacity: 1,
                        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    }}
                />
            )}
            <ClickAwayListener onClickAway={clickAwayHandle}>
                <DrawerContent
                    className={classNames(
                        'drawer-content',
                        classes && classes.content && classes.content,
                    )}
                    styles={styles}
                    anchor={anchor}
                >
                    {children}
                </DrawerContent>
            </ClickAwayListener>
        </DrawerContainer>
    ) : (
        <></>
    );
};

export default Drawer;
